@if (billAccount) {
  <div data-cy="billDetailsContainer">
    @if (oldBillingDesign) {
      <layout-sidebar id="bill-account-detail" data-cy="oldDesign">
        <div class="main">
          <section id="billing-detail">
            <div class="row">
              <div class="column twelve">
                <bill-account-detail-card
                  [billAccount]="billAccount"
                  (silentRegistrationFailureEvent)="silentRegistrationFailure('card')"
                ></bill-account-detail-card>
              </div>
            </div>
            <div class="margin-top-10">
              @if (silentRegistrationErrorCard) {
                <ds-error-message [errorList]="errorList"></ds-error-message>
              }
            </div>
            @if (billAccount.enabledAFT) {
              <div class="row pad-top-20">
                <span dsContent [contentPath]="'billing.enrolledInAft'"></span>
                <span *dsPartnerAFI>{{ contactNumber }}</span>
                <span
                  *dsPartnerConnect
                  dsPartnerContent
                  [brandContent]="'selectPrettyCusCareNumber'"
                ></span>
                <span>.</span>
              </div>
            }
            <div class="row pad-top-20">
              <div class="column twelve">
                <ds-accordion
                  [allowMultipleOpenCategories]="true"
                  [allowToggleAccordion]="true"
                  (expandAllEvent)="expandAllClicked()"
                >
                  @if (!readOnly && (hasAutopayEnabled || isEligibleBillAccountForAutoPay)) {
                    <ds-accordion-category
                      [title]="manageAutoPay"
                      (opening)="toggleAccordion('autopayAccordion', $event)"
                      (closing)="toggleAccordion('autopayAccordion', $event)"
                      [dsAnalyticsClick]="autoPayAccordionAnalytic.link"
                      data-cy="billAccountDetailAccordionManageAutopay"
                    >
                      <div class="accordion-content-wrapper">
                        @if (hasAutopayEnabled || isEligibleBillAccountForAutoPay) {
                          <ds-auto-pay-detail-wrapper
                            [billAccountNumber]="billAccount.billAccountNumber"
                            data-cy="billAccountDetailSetupAutopaySection"
                          ></ds-auto-pay-detail-wrapper>
                        }
                        @if (silentRegistrationErrorAutomatic) {
                          <ds-error-message [errorList]="errorList"></ds-error-message>
                        }
                      </div>
                    </ds-accordion-category>
                  }
                  @if (!billAccount.readOnly) {
                    <ds-accordion-category
                      [title]="myPaymentMethods"
                      (opening)="toggleAccordion('methodsAccordion', $event)"
                      (closing)="toggleAccordion('methodsAccordion', $event)"
                      data-cy="billAccountDetailAccordionManagePaymentMethods"
                    >
                      <div class="accordion-content-wrapper">
                        <p
                          dsContent
                          [contentPath]="'billing.managePaymentsAdvancedCustomerTxt'"
                        ></p>
                        <ds-payment-methods></ds-payment-methods>
                      </div>
                    </ds-accordion-category>
                  }
                  @if (!readOnly) {
                    <ds-accordion-category
                      [title]="manageOneTimePayments"
                      (opening)="toggleAccordion('paymentsAccordion', $event)"
                      (closing)="toggleAccordion('paymentsAccordion', $event)"
                      [startOpen]="accordionStatus.paymentsAccordion"
                      [dsAnalyticsClick]="scheduledPaymentAccordionAnalytic.link"
                      data-cy="billAccountDetailAccordionManageScheduled"
                    >
                      <div class="accordion-content-wrapper">
                        <ds-bill-account-payments-scheduled
                          class="block pad-bottom-20"
                          [billAccountNumber]="billAccount.billAccountNumber"
                          (accordionPaySilentRegFailureEvent)="
                            silentRegistrationFailure('scheduled')
                          "
                        >
                        </ds-bill-account-payments-scheduled>
                        @if (silentRegistrationErrorScheduled) {
                          <ds-error-message [errorList]="errorList"></ds-error-message>
                        }
                      </div>
                    </ds-accordion-category>
                  }
                  @if ((futurePayments$ | async)?.length >= 0 && !isConnectPartner) {
                    <ds-accordion-category
                      [title]="futurePaymentsSchedule"
                      data-cy="billAccountDetailBillFuturePaymentsSchedule"
                      [startOpen]="checkOpenFuturePayment$ | async"
                    >
                      <ds-future-payments [scheduledpayments]="futurePayments$ | async">
                      </ds-future-payments>
                    </ds-accordion-category>
                  }
                  @if (!readOnly && billAccount?.billingMethod === onlineBilling) {
                    <ds-accordion-category
                      [title]="preferences"
                      data-cy="billAccountDetailBillPreferencesAccordion"
                      (opening)="toggleAccordion('preferencesAccordion', $event)"
                      (closing)="toggleAccordion('preferencesAccordion', $event)"
                    >
                      <div class="accordion-content-wrapper">
                        @if (billAccount) {
                          <ds-billing-preferences
                            [billAccount]="billAccount"
                            [hasAutopayEnabled]="hasAutopayEnabled"
                            [autopayEligible]="isEligibleBillAccountForAutoPay"
                          ></ds-billing-preferences>
                        }
                      </div>
                    </ds-accordion-category>
                  }
                  <ds-accordion-category
                    id="{{ paymentHistoryElementIdConst }}"
                    data-cy="billAccountDetailPaymentHistoryAccordion"
                    (opening)="toggleAccordion('paymentHistoryAccordion', $event)"
                    (closing)="toggleAccordion('paymentHistoryAccordion', $event)"
                    [title]="paymentHistory"
                  >
                    <div class="accordion-content-wrapper">
                      <ds-payment-history
                        [hideForDetails]="true"
                        [billAccountNumber]="billAccount.billAccountNumber"
                        [accordionIsOpen]="accordionStatus.paymentHistoryAccordion"
                      ></ds-payment-history>
                    </div>
                  </ds-accordion-category>
                  <ds-accordion-category
                    [title]="statementHistory"
                    data-cy="billAccountDetailBillHistoryAccordion"
                    (opening)="toggleAccordion('billingHistoryAccordion', $event)"
                    (closing)="toggleAccordion('billingHistoryAccordion', $event)"
                    [startOpen]="accordionStatus.billingHistoryAccordion"
                  >
                    <div class="accordion-content-wrapper">
                      <ds-bill-account-statement-history
                        [billAccountNumber]="billAccount.billAccountNumber"
                      ></ds-bill-account-statement-history>
                    </div>
                  </ds-accordion-category>
                  <ng-container>
                    @if (isBam) {
                      <ds-accordion-category
                        [title]="stopManagingAccount"
                        data-cy="billAccountDetailBillStopManagingAccount"
                        (opening)="toggleAccordion('stopManaging', $event)"
                        (closing)="toggleAccordion('stopManaging', $event)"
                      >
                        <div class="accordion-content-wrapper">
                          <ds-bill-account-stop-managing
                            [billAccount]="billAccount"
                            [unAssociatedAccount]="unAssociatedAccount"
                            [deletePreferenceRetry]="
                              matchedBillAccountNotificationState?.deletePrefsRetry
                            "
                          ></ds-bill-account-stop-managing>
                        </div>
                      </ds-accordion-category>
                    }
                  </ng-container>
                </ds-accordion>
              </div>
            </div>
          </section>
        </div>
        <aside class="main-aside">
          <links-agents-sidebar [quickLinksList]="quickLinksOverride"></links-agents-sidebar>
        </aside>
      </layout-sidebar>
    }
  </div>

  @if (newBillingDesign) {
    <div class="details-header-container" data-cy="billDetailsHeaderContainer">
      <h1
        class="details-header"
        dsContent
        [contentPath]="'billing.newBillingDesignTitles.billDetails'"
        data-cy="billDetailsHeader"
      ></h1>
      @for (policySummary of billAccount.policyList; track policySummary) {
        <p class="margin-bottom-20">
          @for (risk of policySummary.riskDescriptionList; track risk) {
            <span data-cy="billAccountPrettyRiskDescription"
              >{{ risk | prettyRiskDescription }}<br
            /></span>
          }
        </p>
      }
    </div>
    <div class="cta-buttons">
      <div class="payment-button-container">
        <button class="icon-button" (click)="goToPaymentHistory()">
          <img src="/assets/images/Payment history.svg" alt="payment history icon image" />
        </button>
        <span class="button-text"
          ><a
            (click)="goToPaymentHistory()"
            dsContent
            [contentPath]="'billing.newBillingDesignTitles.paymentHistory'"
          ></a
        ></span>
      </div>
      <div class="statement-history-button-container">
        <button class="icon-button" (click)="goToStatementHistory()">
          <img src="/assets/images/Statements.svg" alt="statements icon image" />
        </button>
        <span class="button-text"
          ><a
            (click)="goToStatementHistory()"
            dsContent
            [contentPath]="'billing.newBillingDesignTitles.historySubTitle2'"
          ></a
        ></span>
      </div>
    </div>
    <div class="button-text-mobile-container">
      <span class="button-text-mobile"
        ><a
          (click)="goToPaymentHistory()"
          dsContent
          [contentPath]="'billing.newBillingDesignTitles.paymentHistory'"
        ></a
      ></span>
      <span class="button-text-mobile"
        ><a
          (click)="goToStatementHistory()"
          dsContent
          [contentPath]="'billing.newBillingDesignTitles.historySubTitle2'"
        ></a
      ></span>
    </div>

    <div class="row">
      <div class="column twelve">
        <new-bill-account-detail-card
          [billAccount]="billAccount"
          (silentRegistrationFailureEvent)="silentRegistrationFailure('card')"
        ></new-bill-account-detail-card>
      </div>
    </div>
  }

  <div class="margin-top-10">
    @if (silentRegistrationErrorCard) {
      <ds-error-message [errorList]="errorList"></ds-error-message>
    }
  </div>

  @if (billAccount.enabledAFT) {
    <div class="row pad-top-20">
      <span dsContent [contentPath]="'billing.enrolledInAft'"></span>
      <span *dsPartnerAFI>{{ contactNumber }}</span>
      <span *dsPartnerConnect dsPartnerContent [brandContent]="'selectPrettyCusCareNumber'"></span>
      <span>.</span>
    </div>
  }
}
<ds-modal
  [id]="tryAgainModal"
  [closeOthers]="true"
  [maxWidth]="450"
  (onCloseModalEvent)="resetTryAgainCounter()"
>
  <div class="row pad-20">
    <div class="unregister-modal-heading column twelve">
      <span class="error-600-text icon-alert margin-right-10"></span>
      <h3
        dsContent
        [contentPath]="'billing.stopManagingModalHeader'"
        data-cy="stopManagingModalHeader"
        class="pad-top-20"
      ></h3>
    </div>
    <div class="unregister-modal-content column twelve pad-bottom-20">
      <div>
        <span class="success-400-text icon-complete-circle margin-right-10"></span>
        <span
          dsContent
          [contentPath]="'billing.stopManagingModalDeleted'"
          data-cy="stopManagingModalDeleted"
        ></span>
      </div>
      <div>
        <span class="error-600-text icon-alert margin-right-10"></span>
        <span
          dsContent
          [contentPath]="'billing.stopManagingModalFailed'"
          data-cy="stopManagingModalFailed"
        ></span>
      </div>
    </div>
    <div class="unregister-modal-cta column twelve">
      <!--
      stopPropogation needed so click on removed button is not interpreted as click outside modal
      -->
      @if (tryAgainCounter >= 1) {
        <button
          ds-button
          (click)="$event.stopPropagation(); stopManagingTryAgain()"
          [disabled]="deleteInProgress"
          class="-outline fill"
          aria-label="Try Again"
          dsContent
          [contentPath]="'shared.retry'"
        ></button>
      }
      <div class="text-center pad-top-10">
        <span dsContent [contentPath]="'shared.callUsAt'">:</span>
        <a
          dsPartnerContent
          [brandContent]="'selectPrettyCusCareNumber'"
          [brandHref]="'selectCusCareNumberFullHref'"
        ></a>
      </div>
    </div>
  </div>
</ds-modal>
<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper header">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>
